const createActionName = require('../../util').createActionName('user/contact');

import Logger from '../../../utils/Logger';

let { id: module_id } = module;
const logger = new Logger(module_id);

// - start getting contacts (this is not called initally, only after updating contacts)
export const GET_CONTACTS = createActionName('GET_CONTACTS');
// - receive initial contacts
export const RECEIVE_CONTACTS = createActionName('RECEIVE_CONTACTS');
//  - get contacts failed
export const GET_CONTACTS_FAILED = createActionName('GET_CONTACTS_FAILED');

//- start updating/adding contact
export const REQUEST_UPDATE_CONTACT = createActionName(
  'REQUEST_UPDATE_CONTACT'
);

// - updated/added contact.
// API returns updated contacts with the request so this payload includes them
export const RECEIVE_UPDATE_CONTACT = createActionName(
  'RECEIVE_UPDATE_CONTACT'
);

//  - update/add contact failed
export const REQUEST_UPDATE_CONTACT_FAILED = createActionName(
  'REQUEST_UPDATE_CONTACT_FAILED'
);

export const REQUEST_UPDATE_CLOSE_CONTACT = createActionName(
  'REQUEST_UPDATE_CLOSE_CONTACT'
);
export const RECEIVE_UPDATE_CLOSE_CONTACT = createActionName(
  'RECEIVE_UPDATE_CLOSE_CONTACT'
);
export const REQUEST_UPDATE_CLOSE_CONTACT_FAILED = createActionName(
  'REQUEST_UPDATE_CLOSE_CONTACT_FAILED'
);

export const REQUEST_REMOVE_CONTACT = createActionName(
  'REQUEST_REMOVE_CONTACT'
);
export const RECEIVE_REMOVE_CONTACT = createActionName(
  'RECEIVE_REMOVE_CONTACT'
);
export const REQUEST_REMOVE_CONTACT_FAILED = createActionName(
  'REQUEST_REMOVE_CONTACT_FAILED'
);

export const RESET_ERROR = createActionName('RESET_ERROR');

export const receiveContacts = (data) => ({
  type: RECEIVE_CONTACTS,
  payload: { data },
});

export const requestUpdateContact = () => ({
  type: REQUEST_UPDATE_CONTACT,
});

export const receiveUpdateContact = (data) => ({
  type: RECEIVE_UPDATE_CONTACT,
  payload: { data },
});

export const requestUpdateContactFailed = (error) => ({
  type: REQUEST_UPDATE_CONTACT_FAILED,
  payload: { error },
});

export const requestUpdateCloseContact = () => ({
  type: REQUEST_UPDATE_CLOSE_CONTACT,
});

export const receiveUpdateCloseContact = (data) => ({
  type: RECEIVE_UPDATE_CLOSE_CONTACT,
  payload: { data },
});

export const requestUpdateCloseContactFailed = (error) => ({
  type: REQUEST_UPDATE_CLOSE_CONTACT_FAILED,
  payload: { error },
});

export const requestRemoveContact = () => ({
  type: REQUEST_REMOVE_CONTACT,
});

export const receiveRemoveContact = (data) => ({
  type: RECEIVE_REMOVE_CONTACT,
  payload: { data },
});

export const requestRemoveContactFailed = (error) => ({
  type: REQUEST_REMOVE_CONTACT_FAILED,
  payload: { error },
});

export const resetError = () => ({
  type: RESET_ERROR,
});

export const doUpdateContact = (formData) => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(requestUpdateContact());
    services.api
      .updateContact(formData)
      .then((data) => {
        logger.debug({ data });
        return resolve(dispatch(receiveUpdateContact(data)));
      })
      .catch((err) => {
        let errorCode = 'error';

        if (err.code) {
          errorCode += `.${err.code}`;
        }

        return reject(dispatch(requestUpdateContactFailed(err)));
      });
  });
};

export const doUpdateCloseContact =
  (contactId) => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(requestUpdateCloseContact());
      services.api
        .setCloseContact({ contactId })
        .then((data) => {
          logger.debug({ data });
          return resolve(dispatch(receiveUpdateCloseContact(data)));
        })
        .catch((err) => {
          console.log(err);
          let errorCode = 'error';
          if (err.code) {
            errorCode += `.${err.code}`;
          }

          return reject(dispatch(requestUpdateCloseContactFailed(err)));
        });
    });
  };

export const doRemoveContact =
  (contactId) => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(requestRemoveContact(contactId));
      services.api
        .removeContact({ contactId })
        .then((data) => {
          return resolve(dispatch(receiveRemoveContact(data)));
        })
        .catch((err) => {
          console.error(err);
          return reject(dispatch(requestRemoveContactFailed(err)));
        });
    });
  };
